import TravelSummaryContent from 'src/app/flights/shared/TravelSummaryContent';
import { useParams } from 'react-router';
import { FC } from 'react';
import useAirSelectedItineraryManager from '../../hooks/useAirSelectedItineraryManager';
import { IRetryPaymentParams } from '../../types';
import useGetTravelerProfileResponse from '../../hooks/useGetTravelerProfileResponse';

interface ITravelSummaryContainerProps {
  heading: string;
}

const TravelSummary: FC<ITravelSummaryContainerProps> = ({ heading }) => {
  const { pnrId } = useParams<IRetryPaymentParams>();

  const traveler = useGetTravelerProfileResponse();
  const itineraryManager = useAirSelectedItineraryManager();
  const itineraryAllLegs = itineraryManager.GetItineraryAllLegs();

  const primaryTravelerUserId = traveler?.userOrgId?.userId?.id;

  if (!primaryTravelerUserId) {
    return null;
  }

  return (
    <TravelSummaryContent
      showFareRulesAndAmenities
      heading={heading}
      airSelectedItineraryResponseManager={itineraryManager}
      itineraryLegs={itineraryAllLegs}
      fareRulesRequestId={{ pnrId }}
      shouldShowLLFAlert={false}
    />
  );
};

export default TravelSummary;
